import React, { useEffect } from 'react'
import { onBlankLayout } from 'store/slices/themeSlice'
import { TEMPLATE } from 'constants/ThemeConstant'
import { useDispatch } from 'react-redux'

const AppRoute = ({ component: Component, routeKey, blankLayout, ...props }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    const isBlank = blankLayout ? true : false
    dispatch(onBlankLayout(isBlank))
  }, [blankLayout])

  return blankLayout ? (
    <Component {...props} />
  ) : (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: routeKey === '/app/home' ? `calc(100%)` : `calc(100% - ${TEMPLATE.BREADCRUMB_HEIGHT}px)`,
      }}
    >
      <Component {...props} />
    </div>
  )
}

export default AppRoute
